export default __webpack_public_path__ + "static/media/driver_accepted.92e14c31.svg";